import React, { useState } from "react";
import { Link, useLocation} from 'react-router-dom'
import "./Dashboard.scss"; // Import the CSS file for styling
import { ReactComponent as MenuHamIcon } from "../../assets/icons/iconMenu.svg";
import { ReactComponent as CloseIcon } from  "../../assets/icons/iconClose.svg";
import { ReactComponent as MailIcon } from "../../assets/icons/iconContactUs.svg";
import { ReactComponent as LocationIcon } from "../../assets/icons/iconLocation.svg";
import { ReactComponent as ServicesIcon } from "../../assets/icons/iconServices.svg";
import { ReactComponent as AboutUsIcon } from "../../assets/icons/iconAboutUs.svg";
import logoSP from "../../assets/LogoSP.svg";

const Dashboard = () => {
  const location =useLocation();


  function getTileSeccion(){
    if(location.pathname.includes('/about-us'))
        return "About Us" 
    if(location.pathname.includes('/location'))
      return "Location" 
    if(location.pathname.includes('/services'))
      if(location.pathname.length > 9){
        if(location.pathname.includes('/standard'))
          return "Standard Alterations"
        if(location.pathname.includes('/bridal'))
          return "Bridal Alterations"
        if(location.pathname.includes('/specialty'))
          return "Specialty Alterations"
        if(location.pathname.includes('/custom'))
          return "Custom Tailoring"
      }
      else
        return  "Services" 
    if(location.pathname.includes('/contact-us'))
      return  "Contact Us" 
  }
  
  const [servicesDropdown, setServicesDropdown] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
        <nav className="navbar">
          <div className="hamburger-menu">
            <MenuHamIcon  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="iconMenu" title="Open menu alterarions by Sdenka & Paola" aria-label="Open menu" />
            <div className="title">{getTileSeccion()}</div>
            <div
              className={`navbar-menu mobile ${isMobileMenuOpen ? "open" : ""}`}
            >
                <CloseIcon  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="close-menu" title="Close menu alterarions by Sdenka & Paola" aria-label="Close menu" />
                <img
                  className="logo"
                  src={logoSP}
                  alt="Alterations by Sdenka & Paola Logo"
                  aria-label="Logo Sp"
                />
              <ul>
                <li className="submenu-title"   >
                  <MailIcon className="icon" title="Contact with alterarions by Sdenka & Paola" aria-label="Contact Us" />
                  <Link onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} to={`/contact-us`}>Contact Us</Link>
                </li>
                <li className="submenu-title">
                  <LocationIcon className="icon" title="Alterations location" aria-label="Location" />
                  <Link onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} to={`/location`}>Location</Link>
                </li>
                <li className="submenu-title">
                  <AboutUsIcon className="icon" title="About alterarions by Sdenka & Paola" aria-label="About Us" />
                  <Link onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} to={`/about-us`}>About Us</Link>
                </li>
                <li className="submenu-title" style={{marginBottom: "0px"}}>
                  <ServicesIcon className="icon" title="Services at alterarions by Sdenka & Paola" aria-label="Services" />
                  <Link onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} to={`/services`}>Services</Link>
                </li> 

                <li className="submenu-item">
                  <Link onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} to={`/services/standard`}>Standard Alterations</Link>
                </li>
                <li className="submenu-item">
                  <Link onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} to={`/services/bridal`}>Bridal Alterations</Link>
                </li>
                <li className="submenu-item">
                  <Link onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} to={`/services/specialty`}>Specialty Alterations</Link>
                </li>
                <li className="submenu-item">
                  <Link onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} to={`/services/custom`}>Custom Tailoring</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="navbar-menu">
            <Link className={location.pathname.includes('/about-us')? 'menuAClassSelected' : 'menuAClass'} to={`/about-us`}>
            About Us
            </Link>
            <Link className={location.pathname.includes('/location') ? 'menuAClassSelected' : 'menuAClass'} to={`/location`}>
            Location
            </Link>
            <div
              className="services-menu"
              onMouseEnter={() => setServicesDropdown(true)}
              onMouseLeave={() => setServicesDropdown(false)}
            >
              <Link className={location.pathname.includes('/services')? 'menuAClassSelected' : 'menuAClass'} to={`/services`}>
                Services
              </Link>
              {servicesDropdown && (
                <ul className="dropdown-menu">
                  <li className="dropdown-item">
        
                    <Link to={`/services/standard`}>Standard Alterations</Link>
                  </li>
                  <li className="dropdown-item">
                    <Link to={`/services/bridal`}>Bridal Alterations</Link>
                  </li>
                  <li className="dropdown-item">
                    <Link to={`/services/specialty`}>Specialty Alterations</Link>
                  </li>
                  <li className="dropdown-item">
                    <Link to={`/services/custom`}>Custom Tailoring</Link>
                  </li>
                </ul>
              )}
            </div>

            <div className="buttons-Container">

              <button className="book-btn">
                <Link to={`/contact-us`} >Contact Us</Link>
              </button>
            </div>

          </div>
        </nav>
  );
};

export default Dashboard;